import { render, staticRenderFns } from "./custom-input.vue?vue&type=template&id=59b4764c&"
import script from "./custom-input.vue?vue&type=script&lang=js&"
export * from "./custom-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports